var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69989 3.10001H7.29988C5.32027 3.10001 4.32976 3.10001 3.71516 3.71531C3.09985 4.3299 3.09985 5.3204 3.09985 7.3V10.8C3.09985 12.7796 3.09985 13.7701 3.71516 14.3847C4.32976 15 5.32027 15 7.29988 15H8.23999C8.8126 15 9.0982 15 9.3558 14.8936C9.6134 14.7872 9.815 14.5849 10.2203 14.1796L12.0795 12.3204C12.4848 11.9151 12.6864 11.7135 12.7935 11.4559C12.8999 11.1983 12.8999 10.9127 12.8999 10.3401V7.3C12.8999 5.3204 12.8999 4.3299 12.2846 3.71531C11.67 3.10001 10.6795 3.10001 8.69989 3.10001Z",
    stroke: "#6E6E6E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05006 14.65V13.95C9.05006 12.6298 9.05006 11.9704 9.46026 11.5602C9.87046 11.15 10.5299 11.15 11.8501 11.15H12.5501M3.10002 12.9C2.54306 12.9 2.00891 12.6787 1.61508 12.2849C1.22125 11.8911 1 11.3569 1 10.8V5.19999C1 3.2204 1 2.2299 1.6153 1.6153C2.22991 1 3.22042 1 5.20003 1H8.70006C9.25701 1 9.79116 1.22125 10.185 1.61507C10.5788 2.0089 10.8001 2.54304 10.8001 3.1M5.55073 8.69999H8.35075M5.55073 5.89999H10.4508",
    stroke: "#6E6E6E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFileIcon);
export default __webpack_public_path__ + "static/media/CustomFileIcon.ceef9b8be2b2fcd917f73dc96bda974f.svg";
export { ForwardRef as ReactComponent };